export default getText => key =>
  ({
    title: getText('Live Updates', 'Home_Tabs_Appointments_Header'),
  }[key])
